import React, { useState, useEffect } from 'react';
import './App.css';
import TopBar from './components/TopBar/TopBar';
import Channel from './components/Channel/Channel';
import VideoPlayer from './components/VideoPlayer/VideoPlayer';
import Login from './components/Login/Login';
import { channelsData } from './data/channelsData';

import Intro from './components/Intro/Intro';

function App() {
  const [user, setUser] = useState(null);
  const [activeChannel, setActiveChannel] = useState('reality-tv');
  const [videoData, setVideoData] = useState(null);
  // Intro plays first on page load, before anything else
  const [showIntro, setShowIntro] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeChannel]);

  const handleLogin = (username) => {
    setUser({ name: username });
  };

  const handlePlayVideo = (showTitle, videoUrl) => {
    setVideoData({ title: showTitle, url: videoUrl });
  };

  const handleCloseVideo = () => {
    setVideoData(null);
  };

  // Show intro video first — once it ends, show login
  if (showIntro) {
    return <Intro onComplete={() => setShowIntro(false)} />;
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  return (
    <div className="app">
      {!videoData && (
        <>
          <TopBar
            activeChannel={activeChannel}
            onChannelSelect={setActiveChannel}
            channels={channelsData}
            userName={user.name}
          />
          <div className="app-container">
            <main className="main-content">
              {channelsData.map(channel => (
                <Channel
                  key={channel.id}
                  channel={channel}
                  isActive={activeChannel === channel.id}
                  onPlayVideo={handlePlayVideo}
                />
              ))}
            </main>
          </div>
        </>
      )}

      {videoData && (
        <VideoPlayer
          title={videoData.title}
          videoUrl={videoData.url}
          onClose={handleCloseVideo}
        />
      )}
    </div>
  );
}

export default App;
